import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AnalyticsService } from 'libs/shared/src/lib/services/analytics.service';

@Component({
  selector: 'blu-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  standalone: true,
  imports: [RouterLink],
})
export class IndexComponent {
  constructor(public analyticsService: AnalyticsService) {}
}
